<thead>
    <tr>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Результат</p>
            <div class="desc_item3">
                Выберите результат из списка. В план мониторинга могут быть включены результаты, имеющиеся в цепочке социальных результатов. Не нашли нужный результат, добавьте его в цепочку социальных результатов.  
            </div>
        </td>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Вопрос</p>
            <div class="desc_item3">
                Сформулируйте оценочный вопрос о том, что именно необходимо узнать для оценки достижения результата.
            </div>
        </td>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Показатель</p>
            <div class="desc_item3">
                Начните формулировать показатель со слов «Число», «Количество»,  «Доля» и продолжите, опираясь на оценочный вопрос.
            </div>
        </td>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Метод</p>
            <div class="desc_item3">
                Выберите метод из списка. В данном пункте указывается именно метод, не инструмент.
            </div>
        </td>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Инструмент</p>
            <div class="desc_item3">
                Выберите инструмент из списка. Если не нашли подходящий, напишите название своего. Добавьте инструмент в личную библиотеку инструментов. 
            </div>
        </td>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Частота сбора</p>
            <div class="desc_item3">
                Укажите, как часто необходимо собирать данные.  Например, еженедельно/ежемесячно/ежегодно.  Или - при входе и выходе из программы. Или - на первом и последнем занятии. 
            </div>
        </td>
        <td class="hintblock relative">
            <img src="/newpion/static/pionfront/assets/img/book.png">
            <p>Отчетность и использование</p>
            <div class="desc_item3">
                Укажите, в каких отчетах и в каких целях будет использованы данные подсчета показателя.
            </div>
        </td>
        <td class="hintblock relative">
            <p>Действия</p>
        </td>
    </tr>
</thead>
